import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5564b142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "overview-museum" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","font-size":"9pt"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"50%","padding-left":"10px"} }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "Must enter with host"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Wajib masuk bersama host ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "Payment before entry"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Lunaskan pembayaran sebelum masuk ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "Wear a mask"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Pakai masker ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "Up to 5 guests per tour"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Tidak lebih dari 5 tamu per tour ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "Don’t wander off from your group"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Jangan berpencar dari grup ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"50%","padding-right":"10px"} }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "No food/drinks in museum"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Dilarang membawa makanan/minuman ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "Keep the area comfortable"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Jaga kenyamanan area ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "No baby strollers"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Dilarang membawa stroller bayi ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { style: {"color":"#5a2e00"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00"} }, "No flash photography"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Dilarang menggunakan flash ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { style: {"padding-bottom":"10px"} }, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "Children must be supervised"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Anak-anak wajib didampingi orang dewasa ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("b", { style: {"color":"#5a2e00","font-family":"'AppFontBold'"} }, "No heels if possible"),
        /*#__PURE__*/_createTextVNode(),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Hindari sepatu hak tinggi ")
      ])
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Beli Tiket ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_ion_button, {
          class: "atsiri-btn",
          expand: "block",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: 'atsiri-museum-schedule'}))),
          style: {"color":"#5a2e00"}
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'Home'}))),
          class: "anchor-home",
          style: {"color":"#5a2e00"}
        }, "Home")
      ])
    ]),
    _: 1
  }))
}